<template>
  <chat-layout>
    <template v-slot:chat-message-list>
      <chat-message-list />
    </template>
    <template v-slot:chat-message-follow-up>
      <chat-message-follow-up @botFollowUpClick="followUpClick" />
    </template>
    <template v-slot:chat-message-input>
      <chat-input :follow-up-active-text="followUpText" />
    </template>
  </chat-layout>
</template>

<script>
import ChatMessageList from './chat/ChatMessageList'
import ChatLayout from './chat/ChatLayout'
import ImLeftSidebar from '../leftSidebar/ImLeftSidebar'
import ChatInput from './chat/ChatInput'
import ChatMessageFollowUp from './chat/ChatMessageFollowUp'
export default {
  name: 'ChatWrap',
  components: {
    ImLeftSidebar,
    ChatLayout,
    ChatMessageList,
    ChatInput,
    ChatMessageFollowUp
  },
  data () {
    return {
      followUpText: ''
    }
  },
  methods: {
    followUpClick (text) {
      this.followUpText = text
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/im/right/ChatWrap.vue